import * as React from "react";
import { connect } from "react-redux";
import { Form, Input, Row, Col } from "antd";
import { FormattedMessage } from "react-intl";
import {
  createRequest,
  updateRequest,
  fetchItemRequest
} from "@actions/user-role";
import { UserRole } from "@models/user-role";
import { Resource } from "@models/resource";
import ResourceMultiSelection from "@components/resources/selection/ResourceMultiSelection";
import { ResourceMultiSelectionReturnValue } from "@components/resources/selection/ResourceMultiSelection";
import { resourceMultiSelectionDefaultReturnValue } from "../resources/selection/ResourceMultiSelection";
import { Menu } from "@models/menu";
import MenuMultiSelection from "@components/menus/selection/MenuMultiSelection";
import { MenuMultiSelectionReturnValue } from "@components/menus/selection/MenuMultiSelection";
import { menuMultiSelectionDefaultReturnValue } from "@components/menus/selection/MenuMultiSelection";
import withFormWrapper from "@hocs/withFormWrapper";

interface PropsFromState {
  loading: boolean;
  errors?: string;
  form: any;
  userRole?: UserRole;
  menus: Menu[];
  is_fetched_menus: boolean;
  is_fetched_resources: boolean;
  resources: Resource[];
  id: string;
}

interface PropsFromDispatch {
  createRequest: typeof createRequest;
  updateRequest: typeof updateRequest;
  fetchItemRequest: typeof fetchItemRequest;
}

type UserRoleFormStateShape = {
  visible: boolean;
  title: string;
  menus: [];
  is_fetched_menus: boolean;
  is_fetched_resources: boolean;
  resources: [];
  id: string;
};

type UserRoleFormAllProps = PropsFromState & PropsFromDispatch;

class UserRoleForm extends React.Component<
  UserRoleFormAllProps,
  UserRoleFormStateShape
> {
  private resources: ResourceMultiSelectionReturnValue = resourceMultiSelectionDefaultReturnValue;
  private menus: MenuMultiSelectionReturnValue = menuMultiSelectionDefaultReturnValue;

  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      ...this.getStateFromProps(props.userRole)
    };
  }

  getStateFromProps = (userRole: UserRole | null = {}) => {
    const obj = userRole || {};
    return {
      title: obj.title || "",
      resources: obj.resources || [],
      menus: obj.menus || [],
      id: obj.id
    };
  };
 
  /**
   * Set cover and avatar ids in a form values to handle validation by form
   */
  getValues = () => {
    let returnValues: any = null;
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        returnValues = {
          userRoleDetails: values,
          resources: this.resources,
          menus: this.menus
        };
      }
    });

    return {
      payload: returnValues,
      id: this.state.id
    };
  };

  onChangeResources = (resources: ResourceMultiSelectionReturnValue) => {
    this.resources = resources;
  };

  onChangeMenus = (menus: MenuMultiSelectionReturnValue) => {
    this.menus = menus;
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <Form>
        <Row gutter={24}>
          <Col span={8}>
            <Form.Item
              label={
                <FormattedMessage id="app.title" defaultMessage={`Title`} />
              }
            >
              {getFieldDecorator("title", {
                initialValue: this.state.title,
                rules: [
                  {
                    whitespace: true,
                    required: true,
                    message: (
                      <FormattedMessage
                        id="app.title_is_required"
                        defaultMessage={`Title is required!`}
                      />
                    )
                  }
                ]
              })(<Input />)}
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label={
                <FormattedMessage
                  id="app.resources"
                  defaultMessage={`Resources`}
                />
              }
            >
              {getFieldDecorator("resources", {})(<Input type={`hidden`} />)}
              <ResourceMultiSelection
                selectedResources={this.state.resources}
                onChange={this.onChangeResources}
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label={
                <FormattedMessage id="app.menus" defaultMessage={`Menus`} />
              }
            >
              {getFieldDecorator("menus", {})(<Input type={`hidden`} />)}
              <MenuMultiSelection
                selectedMenus={this.state.menus}
                onChange={this.onChangeMenus}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    );
  }
}

const WrappedUserRoleForm = Form.create({ name: "user-role-form" })(
  UserRoleForm
);
export default withFormWrapper(WrappedUserRoleForm);
